<template>
  <div class="filter-tag-general-wrapp" v-if="isSpisi">
    <v-menu
      ref="menu-tag-filter"
      class="ovaj"
      v-model="menu1"
      :close-on-content-click="false"
      transition="scale-transition"
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" @click="menu1 = !menu1" v-on="on">
          <div class="file-tree-viewer-tag">
            <div class="tag-filter-wrapp">
              <div v-if="active_tags.length == 0">{{ $t("components.file_management.filterTag.selectByCategory") }}</div>
              <div v-else>{{ $t("components.file_management.filterTag.categoriesSelected", { count: active_tags.length }) }}</div>
              <div class="tag-filter-icon">
                <svg
                  width="100%"
                  height="100%"
                  viewBox="0 0 161 159"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  xml:space="preserve"
                  xmlns:serif="http://www.serif.com/"
                  style="
                    fill-rule: evenodd;
                    clip-rule: evenodd;
                    stroke-miterlimit: 10;
                  "
                >
                  <g transform="matrix(0.75,0,0,0.75,-50107.4,-2250.81)">
                    <g transform="matrix(5.55556,0,0,5.55556,51105.4,0)">
                      <g transform="matrix(1,0,0,1,2846.3,545.218)">
                        <path
                          d="M0,14.032L-14.032,14.032L-14.032,3.104C-14.032,1.39 -12.642,0 -10.928,0L0,0L0,14.032Z"
                          style="fill: rgb(172, 110, 204); fill-rule: nonzero"
                        />
                      </g>
                    </g>
                    <g transform="matrix(5.55556,0,0,5.55556,51105.4,0)">
                      <g transform="matrix(1,0,0,1,2860.33,545.218)">
                        <path
                          d="M0,14.032L-14.032,14.032L-14.032,0L-3.104,0C-1.39,0 0,1.39 0,3.104L0,14.032Z"
                          style="fill: rgb(67, 158, 209); fill-rule: nonzero"
                        />
                      </g>
                    </g>
                    <g transform="matrix(5.55556,0,0,5.55556,51105.4,0)">
                      <g transform="matrix(1,0,0,1,2846.3,573.282)">
                        <path
                          d="M0,-14.032L14.032,-14.032L14.032,-3.104C14.032,-1.39 12.642,0 10.928,0L0,0L0,-14.032Z"
                          style="fill: rgb(229, 137, 92); fill-rule: nonzero"
                        />
                      </g>
                    </g>
                    <g transform="matrix(5.55556,0,0,5.55556,51105.4,0)">
                      <g transform="matrix(1,0,0,1,2832.26,573.282)">
                        <path
                          d="M0,-14.032L14.032,-14.032L14.032,0L3.104,0C1.39,0 0,-1.39 0,-3.104L0,-14.032Z"
                          style="fill: rgb(125, 188, 125); fill-rule: nonzero"
                        />
                      </g>
                    </g>
                    <g transform="matrix(5.55556,0,0,5.55556,51105.4,0)">
                      <g transform="matrix(1,0,0,1,2856.86,545.219)">
                        <path
                          d="M0,28.063L-21.552,28.063C-23.466,28.063 -25.018,26.512 -25.018,24.598L-25.018,3.465C-25.018,1.551 -23.466,0 -21.552,0L0,0C1.914,0 3.466,1.551 3.466,3.465L3.466,24.598C3.466,26.512 1.914,28.063 0,28.063Z"
                          style="
                            fill: none;
                            fill-rule: nonzero;
                            stroke: rgb(220, 220, 226);
                            stroke-width: 1px;
                          "
                        />
                      </g>
                    </g>
                    <g transform="matrix(5.55556,0,0,5.55556,51105.4,0)">
                      <g transform="matrix(0,-1,-1,0,2860.33,559.25)">
                        <path
                          d="M-14.032,14.032L14.032,14.032"
                          style="
                            fill: none;
                            fill-rule: nonzero;
                            stroke: rgb(220, 220, 226);
                            stroke-width: 1px;
                          "
                        />
                      </g>
                    </g>
                    <g transform="matrix(5.55556,0,0,5.55556,51105.4,0)">
                      <g transform="matrix(1,0,0,1,2832.26,559.25)">
                        <path
                          d="M0,0L28.064,0"
                          style="
                            fill: none;
                            fill-rule: nonzero;
                            stroke: rgb(220, 220, 226);
                            stroke-width: 1px;
                          "
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div>
        <div class="drop-tag-general-wrapp">
          <div class="header-tag-wrapp">
            <div class="file-tree-viewer-tag">
              <div class="tag-filter-wrapp">
                <div class="longer-title">{{ $t("components.file_management.filterTag.selectDocuments") }}</div>
                <div class="tag-filter-icon">
                  <svg
                    width="100%"
                    height="100%"
                    viewBox="0 0 161 159"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    xml:space="preserve"
                    xmlns:serif="http://www.serif.com/"
                    style="
                      fill-rule: evenodd;
                      clip-rule: evenodd;
                      stroke-miterlimit: 10;
                    "
                  >
                    <g transform="matrix(0.75,0,0,0.75,-50107.4,-2250.81)">
                      <g transform="matrix(5.55556,0,0,5.55556,51105.4,0)">
                        <g transform="matrix(1,0,0,1,2846.3,545.218)">
                          <path
                            d="M0,14.032L-14.032,14.032L-14.032,3.104C-14.032,1.39 -12.642,0 -10.928,0L0,0L0,14.032Z"
                            style="fill: rgb(172, 110, 204); fill-rule: nonzero"
                          />
                        </g>
                      </g>
                      <g transform="matrix(5.55556,0,0,5.55556,51105.4,0)">
                        <g transform="matrix(1,0,0,1,2860.33,545.218)">
                          <path
                            d="M0,14.032L-14.032,14.032L-14.032,0L-3.104,0C-1.39,0 0,1.39 0,3.104L0,14.032Z"
                            style="fill: rgb(67, 158, 209); fill-rule: nonzero"
                          />
                        </g>
                      </g>
                      <g transform="matrix(5.55556,0,0,5.55556,51105.4,0)">
                        <g transform="matrix(1,0,0,1,2846.3,573.282)">
                          <path
                            d="M0,-14.032L14.032,-14.032L14.032,-3.104C14.032,-1.39 12.642,0 10.928,0L0,0L0,-14.032Z"
                            style="fill: rgb(229, 137, 92); fill-rule: nonzero"
                          />
                        </g>
                      </g>
                      <g transform="matrix(5.55556,0,0,5.55556,51105.4,0)">
                        <g transform="matrix(1,0,0,1,2832.26,573.282)">
                          <path
                            d="M0,-14.032L14.032,-14.032L14.032,0L3.104,0C1.39,0 0,-1.39 0,-3.104L0,-14.032Z"
                            style="fill: rgb(125, 188, 125); fill-rule: nonzero"
                          />
                        </g>
                      </g>
                      <g transform="matrix(5.55556,0,0,5.55556,51105.4,0)">
                        <g transform="matrix(1,0,0,1,2856.86,545.219)">
                          <path
                            d="M0,28.063L-21.552,28.063C-23.466,28.063 -25.018,26.512 -25.018,24.598L-25.018,3.465C-25.018,1.551 -23.466,0 -21.552,0L0,0C1.914,0 3.466,1.551 3.466,3.465L3.466,24.598C3.466,26.512 1.914,28.063 0,28.063Z"
                            style="
                              fill: none;
                              fill-rule: nonzero;
                              stroke: rgb(220, 220, 226);
                              stroke-width: 1px;
                            "
                          />
                        </g>
                      </g>
                      <g transform="matrix(5.55556,0,0,5.55556,51105.4,0)">
                        <g transform="matrix(0,-1,-1,0,2860.33,559.25)">
                          <path
                            d="M-14.032,14.032L14.032,14.032"
                            style="
                              fill: none;
                              fill-rule: nonzero;
                              stroke: rgb(220, 220, 226);
                              stroke-width: 1px;
                            "
                          />
                        </g>
                      </g>
                      <g transform="matrix(5.55556,0,0,5.55556,51105.4,0)">
                        <g transform="matrix(1,0,0,1,2832.26,559.25)">
                          <path
                            d="M0,0L28.064,0"
                            style="
                              fill: none;
                              fill-rule: nonzero;
                              stroke: rgb(220, 220, 226);
                              stroke-width: 1px;
                            "
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="selection-tag-wrapp">
            <div
              v-for="single_tag in tag_list"
              :key="single_tag.id"
              class="inside-tag-wrapp"
            >
              <div class="square-checkbox" @click="setActiveTag(single_tag)">
                <v-icon v-if="isTagInside(single_tag.id)">mdi-check</v-icon>
              </div>
              <div class="file-tree-viewer-tag">
                <div
                    @click="setActiveTag(single_tag)"
                  :class="[
                    'single-file-tag',
                    single_tag.color + '-tag',
                    isTagInside(single_tag.id) ? 'selected-tag' : '',
                  ]"
                >
                  {{ single_tag.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="footer-tag-wrapp">
            <div class="action-name">{{ $t("components.file_management.filterTag.confirmAndClose") }}</div>
            <div class="action-switch-button" @click="menu1 = false">
              <v-icon>mdi-minus</v-icon>
            </div>
          </div>
        </div>
      </div>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    filtered_doc_number: Number,
  },
  data() {
    return {
      menu1: false,
      tag_list: [],
      active_tags: [],
      active_tag: null,
    };
  },
  async created() {
    this.tag_list = this.$store.state.availableFileTags;
  },
  computed:{
    isSpisi()
    {
      console.log("is spisi", this.$router["currentRoute"].path.includes("spisi"))
      return this.$router["currentRoute"].path.includes("spisi")
    }
  },

  methods: {
    isTagInside(tag_id) {
      return this.active_tags.filter((p) => p.id == tag_id).length > 0;
    },
    setActiveTag(sel_tag) {

      if (this.active_tags.filter((p) => p.id == sel_tag.id).length > 0) {
        this.active_tags = this.active_tags.filter((p) => p.id != sel_tag.id);
      } else {
        this.active_tags.push(sel_tag);
      }


      this.$emit("filter_change", this.active_tags);
    },
  },
};
</script>